export default {
  HOST: "https://gentle-ridge-36852.herokuapp.com/",
  WEBSOCKET_HOST: "wss://gentle-ridge-36852.herokuapp.com/",
  DISCORD_CLIENT_ID: "686324632013242398",
  DISCORD_PERMISSIONS: "268437552"
}